function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.79,25.75h12.02c-.21,2.01-.31,4.1-.31,6.25s.11,4.24.31,6.25H7.79c-.52-2-.79-4.09-.79-6.25s.27-4.25.79-6.25ZM20.21,22.62h-11.4c2.93-7.24,9.14-12.78,16.8-14.8-2.49,3.34-4.42,8.56-5.4,14.8ZM20.21,41.38c.98,6.24,2.91,11.47,5.4,14.8-7.66-2.02-13.87-7.57-16.8-14.8h11.4ZM41.38,32c0,2.17-.12,4.26-.32,6.25h-18.1c-.21-1.99-.32-4.08-.32-6.25s.12-4.26.32-6.25h18.1c.21,1.99.32,4.08.32,6.25ZM40.62,22.62h-17.25c.6-3.55,1.51-6.7,2.64-9.25,1.03-2.31,2.17-3.98,3.27-5.03,1.09-1.04,2-1.35,2.71-1.35s1.62.31,2.71,1.35c1.1,1.05,2.25,2.72,3.27,5.03,1.13,2.54,2.04,5.68,2.64,9.25ZM26.01,50.61c-1.13-2.54-2.04-5.68-2.64-9.24h17.25c-.6,3.55-1.51,6.7-2.64,9.24-1.03,2.3-2.17,3.98-3.27,5.03-1.09,1.05-2,1.36-2.71,1.36s-1.62-.31-2.71-1.35c-1.1-1.05-2.25-2.72-3.27-5.03h0ZM55.18,22.62h-11.4c-.98-6.24-2.91-11.47-5.4-14.8,7.65,2.02,13.87,7.57,16.79,14.8h.01ZM55.18,41.38c-2.93,7.24-9.14,12.78-16.79,14.8,2.49-3.34,4.41-8.56,5.4-14.8h11.4,0ZM44.19,25.75h12.02c.52,2,.79,4.09.79,6.25s-.27,4.25-.79,6.25h-12.02c.21-2.01.31-4.1.31-6.25s-.11-4.24-.31-6.25Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/chooseLanguageIc.38bf304e.svg";
export { SvgComponent as ReactComponent };